<script lang="ts" setup generic="T">
withDefaults(
  defineProps<{
    items: T[]
    type?: 'ordered' | 'unordered'
  }>(),
  {
    type: 'unordered',
  },
)

defineSlots<{
  default: (scope: { item: T }) => void
}>()
</script>

<template>
  <component v-if="items.length > 0" :is="type === 'ordered' ? 'ol' : 'ul'" class="list">
    <li v-for="item in items">
      <slot v-bind="{ item }" />
    </li>
  </component>
</template>

<style lang="scss" scoped>
.list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.25em;
}
</style>
